// extracted by mini-css-extract-plugin
export default {"table":"servicesDetails_table__1dpVW"};